export default __webpack_public_path__ + "static/media/rocket_anim_80.cfa70d39.png";